// Does a ray END on the HUD? One rule for the XR controller rays (web-xr.js) and the desktop
// mouse (sector-map.js onPointerUp): a ray ends on any painted HUD surface — panels, bars, buttons,
// rows, text — and anywhere on an OPENED page or overlay (hud-panels.js marks them `rayOpaque`,
// gaps included). Still see-through, on purpose: the LCARS frame's empty content area (the map
// must stay reachable through it), hidden subtrees (parked keyboard), invisible hit planes and
// fully transparent layout boxes (spacers, row containers). Labels live outside game.gui.
// User 2026-10-10: "the rays should not go through; the labels are the exception, not the rule";
// 2026-10-11: a click on the city under the HUD must still reach the planet.
export function guiSurfaceHitRay(raycaster) {
	if (!raycaster || !game.gui || !game.gui.children.length) return null;
	for (const hit of raycaster.intersectObject(game.gui, true)) {
		const o = hit.object;
		if (!o.isMesh) continue;
		let shown = true, opaque = false;
		for (let n = o; n && n !== game.gui; n = n.parent) { if (n.visible === false) { shown = false; break; } if (n.userData?.rayOpaque) opaque = true; }
		// three's Raycaster ignores `visible`: a hidden HUD (phones start with it hidden) still yields
		// hits on its frame's button proxies — they must not swallow map taps (2026-10-17)
		if (!shown) continue;
		// a SHOWN frame button's or clickable label's hit proxy IS the frame's own surface: the ray and the
		// map click end there (a click in the brand label's margins fired the link AND the map, 2026-10-16)
		if (o.lcarsBox && o.clickable) return hit;
		if (o.material && o.material.visible === false) continue;
		if (opaque) return hit;
		const lcars = o.parent && o.parent.frame === o ? o.parent : null;
		if (lcars) {
			if (lcars.backgroundColor && lcars.backgroundColor[3] > 0) return hit; // a filled panel
			const p = o.worldToLocal(hit.point.clone());
			const ca = lcars.contentArea;
			if (Math.abs(p.x - ca.x) < ca.w / 2 && Math.abs(p.y - ca.y) < ca.h / 2) continue; // the hole
			return hit; // a bar
		}
		if (o.isBox) {
			const lp = o.layoutProps;
			const bg = lp && lp.backgroundColor;
			const alpha = Array.isArray(bg) ? (bg[3] ?? 1) : (bg ? 1 : 0);
			const border = !!(lp && lp.borderWidths && lp.borderWidths.some(w => w > 0));
			if (alpha > 0.02 || border) return hit;
			continue;
		}
		return hit; // text, scrollbars, other painted meshes
	}
	return null;
}
